import { ZERO } from '@drift-labs/sdk';
import { useMemo } from 'react';
import { useCurrentAccountPositions } from 'src/hooks/query/accountTradingData/usePositions';

export const useNonZeroOpenPerpPositionCount = (includeUnsettled?: boolean) => {
	const positions = useCurrentAccountPositions();

	const openPerpPositionsCount = useMemo(() => {
		if (!positions) return 0;

		const nonZeroOpenPerpPositions = positions.filter((position) => {
			if (!position.baseSize.eq(ZERO)) return true;
			if (includeUnsettled) return !position.unsettledPnl.eq(ZERO);
			return false;
		});

		return nonZeroOpenPerpPositions.length;
	}, [positions, includeUnsettled]);

	return openPerpPositionsCount;
};
